import React from 'react';

const AsistenciaViajeroContext = React.createContext({
    destinos: null,
    isReady: null
});

export default AsistenciaViajeroContext;